import script from "./AudioMessage.vue?vue&type=script&setup=true&lang=js"
export * from "./AudioMessage.vue?vue&type=script&setup=true&lang=js"

import "./AudioMessage.vue?vue&type=style&index=0&id=0d1292ba&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d1292ba"]])

export default __exports__